import { columns } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function ColumnsSection() {
  return (
    <section id="columns" className="scroll-mt-24 bg-background-50 py-10 md:py-14">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="WATCH GUIDE"
          title="观影指南 · 编辑专栏"
          desc="挑不动的时候，交给我们的编辑替你理一理。"
          actionLabel="更多专栏"
          actionHref="#columns"
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {columns.map((col) => (
            <a
              key={col.id}
              href="#library"
              className="group bg-background-100 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors"
            >
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={col.image}
                  alt={`${col.title} 观影指南配图`}
                  title={`${col.title} - 青苹果影院观影指南`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <span className="text-[11px] font-medium text-accent-700 bg-accent-100 px-2 py-0.5 rounded-full">
                  {col.kicker}
                </span>
                <h3 className="mt-2 text-base md:text-lg font-bold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                  {col.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {col.excerpt}
                </p>
                <div className="mt-3 inline-flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-time-line" />
                  {col.read}读完
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}